import React from "react";
import Hero from '../components/home/hero';
import SocialProof from '../components/home/trusted';
import Features from '../components/home/features';
import Stats from '../components/home/stats';
import Footer from '../components/footer';
// import Testimonials from '../components/home/testimonials';
import FAQ from "../components/home/faq";
import DownloadCTA from "../components/home/download";
import WhoWeEmpower from "../components/home/empower/empowered";
import WhoWeEmpowerMobile from "../components/home/empower/empowered-mobile";
import HeaderAny from "../components/header";
import MobileNav from "../components/header-mobile";
import WhyChooseUs from "./why_choose_us";
import Testimonials from "../components/home/testimonal";
import AuthenticityBanner from "./authenticity_banner";
// import Testimonials from "../components/home/testimonal";

function Landing() {
  return (
    <div>
      <div>
        <div className="web-only">
          <HeaderAny />
        </div>
        <div className="mobile-only">
          <MobileNav />
        </div>
      </div>
      <Hero />
      <SocialProof />
      <WhyChooseUs />
      <Features />
      <div>
        <div className="web-only">
          <WhoWeEmpower />
        </div>
        <div className="mobile-only">
          <WhoWeEmpowerMobile />
        </div>
      </div>
      {/* <Stats /> */}
      <AuthenticityBanner />
      <Testimonials />
      <FAQ />
      <DownloadCTA />
      <Footer />
    </div>
  );
}

export default Landing;
